$(function () {
    //animation library
    if (window.AOS) {
        window.AOS.init();
    }

    //accordion logic
    $('.a-header').on('click', function () {
        //if user clicked on an open accordion
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next().slideUp();
            $(this).find('i').removeClass('fa-minus').addClass('fa-plus');
        }
        //user clicked on closed accordion
        else {
            //setup some vars to make life easy peezy
            var $thisH = $(this);
            var $thisB = $(this).next();
            var $thisI = $(this).find('i');

            //close all open accords
            $('.single-accordion .a-body').slideUp();
            $('.single-accordion .a-header').removeClass('open');
            $('.single-accordion .a-header i').removeClass('fa-minus').addClass('fa-plus');

            //open the clicked accord
            $thisB.slideDown();
            $thisH.addClass('open');
            $thisI.removeClass('fa-plus').addClass('fa-minus');
        }
    });
    //open the first accordion on load
    $('.a-header').eq(0).trigger('click');

    $('.inline-state-select').on('change', function () {
        window.location.href = $(this).val();
    });
});